import React from "react";
import {
  FormControlLabel,
  IconButton,
  Menu,
  MenuItem,
  TablePagination,
  Tooltip,
  withStyles,
} from "@material-ui/core";
import MaterialTable from "material-table";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { DeleteTwoTone, EditTwoTone } from "@material-ui/icons";
import PreviewTwoToneIcon from "@mui/icons-material/PreviewTwoTone";
import { useHistory } from "react-router-dom";
import {
  ContentTextEllipsis,
  useStyles,
  FormsContainer,
} from "./ListOfForms.styled";
import moment from "moment";
import { Col, Row } from "react-bootstrap";
import { AntSwitch } from "../../helpers/antSwitch";
import { theme as themeConfig } from "../../themes/themes";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: themeConfig.neutral.gray[2500],
    margin: "9 0",
    color: "white",
    border: "1px solid #dadde9",
  },
}))(Tooltip);

const ListOfForms = ({
  toggleChecked,
  handleClickActions,
  handleCloseActions,
  handleEditForm,
  setOpenDeleteModal,
  anchorEl,
  setAnchorEl,
  anchorSelected,
  setAnchorSelected,
  myForms,
  handleChangePage,
  handleChangeRowsPerPage,
  rowsPerPageOptions,
  rowsPerPage,
  page,
  allPages,
}) => {
  const history = useHistory();
  const classes = useStyles();
  return (
    <>
      <FormsContainer>
        <MaterialTable
          style={{ boxShadow: "none", margin: "0 15px" }}
          title=""
          columns={[
            {
              title: "ID",
              field: "idForm",
              type: "string",
              cellStyle: {
                textAlign: "center",
                padding: "0px 16px",
              },
            },
            {
              title: "Form Name",
              field: "name",
              type: "string",
              cellStyle: {
                textAlign: "center",
                padding: "0px 16px",
              },
              render: (rowData) => {
                return (
                  <ContentTextEllipsis>{rowData.name}</ContentTextEllipsis>
                );
              },
            },
            {
              title: "Description",
              field: "description",
              type: "string",
              cellStyle: {
                textAlign: "center",
                padding: "0px 16px",
              },
              render: (rowData) => {
                return (
                  <ContentTextEllipsis>
                    {rowData.description}
                  </ContentTextEllipsis>
                );
              },
            },
            {
              title: "Country",
              field: "country",
              type: "string",
              cellStyle: {
                textAlign: "center",
                padding: "0px 16px",
              },
              render: (rowData) => rowData?.city ? rowData?.city?.countryName : "--",
            },
            {
              title: "City",
              field: "city",
              type: "string",
              cellStyle: {
                textAlign: "center",
                padding: "0px 16px",
              },
              render: (rowData) => rowData?.city ? rowData?.city?.cityName : "--",
            },
            {
              title: "LOB",
              field: "lobs",
              type: "string",
              filtering: false,
              cellStyle: {
                textAlign: "center",
                padding: "0px 16px",
              },
              render: (rowData) =>
                rowData && (
                  <>
                    <HtmlTooltip
                      arrow
                      placement="right"
                      title={
                        <>
                          <ul
                            style={{
                              padding: "1em 0em 1em 1.5em",
                              margin: "0",
                              listStyleType: "circle",
                              lineHeight: "1.3",
                            }}
                          >
                            {rowData?.lobs?.map((l, i) => (
                              <li key={i} style={{ fontSize: "11px" }}>
                                {l.name}
                              </li>
                            ))}
                          </ul>
                        </>
                      }
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: themeConfig.primary.purple,
                            borderRadius: "99px",
                            width: "22px",
                            height: "22px",
                            justifyContent: "center",
                            display: "flex",
                            alignItems: "center",
                            color: "white",
                          }}
                        >
                          {rowData?.lobs?.length}
                        </div>
                      </div>
                    </HtmlTooltip>
                  </>
                ),
            },
            {
              title: "Created Date",
              field: "creationDate",
              type: "string",
              cellStyle: {
                textAlign: "center",
                padding: "0px 16px",
              },
              render: (rowData) => {
                return <>{moment(rowData.creationDate).format("YYYY-MM-DD")}</>;
              },
            },
            {
              title: "Disable/ Enable",
              field: "edit_state",
              type: "string",
              sorting: false,
              filtering: false,
              cellStyle: {
                textAlign: "center",
                padding: "0px 16px",
              },
              render: (rowData) =>
                rowData && (
                  <FormControlLabel
                    control={
                      <AntSwitch
                        size="small"
                        checked={
                          rowData?.recordStatus === "Active" ? true : false
                        }
                        onChange={() => toggleChecked(rowData)}
                      />
                    }
                  />
                ),
            },
            {
              title: "Actions",
              field: "internal_action",
              sorting: false,
              filtering: false,
              cellStyle: {
                textAlign: "center",
                padding: "0px 16px",
              },
              render: (rowData) =>
                rowData && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Tooltip title="Actions">
                      <IconButton
                        aria-label="more"
                        aria-controls="long-menu"
                        aria-haspopup="true"
                        className={classes.active}
                        onClick={(e) => handleClickActions(e, rowData)}
                      >
                        <MoreVertIcon />
                      </IconButton>
                    </Tooltip>

                    <Menu
                      id="long-menu"
                      anchorEl={anchorEl}
                      open={Boolean(
                        anchorSelected === rowData.idForm ? true : false
                      )}
                      keepMounted
                      transition={"true"}
                      onClose={() => handleCloseActions()}
                    >
                      <MenuItem onClick={() => handleEditForm(rowData)}>
                        <EditTwoTone />
                        &nbsp; Edit
                      </MenuItem>
                      <MenuItem
                        disabled={
                          rowData?.recordStatus === "Active" ? true : false
                        }
                        onClick={() => {
                          setAnchorEl(null);
                          setAnchorSelected(null);
                          setOpenDeleteModal(rowData);
                        }}
                      >
                        <DeleteTwoTone />
                        &nbsp; Delete
                      </MenuItem>
                      <MenuItem
                        onClick={() =>
                          history.push({
                            pathname: "/PreviewForm",
                            state: { data: rowData },
                          })
                        }
                      >
                        <PreviewTwoToneIcon />
                        &nbsp; Preview
                      </MenuItem>
                    </Menu>
                  </div>
                ),
            },
          ]
            .map((item) => ({ ...item }))
            .filter((item) => {
              return item.title !== "";
            })}
          data={myForms}
          options={{
            maxBodyHeight: 550,
            paging: false,
            search: false,
            headerStyle: {
              textAlign: "center",
              zIndex: 1,
              fontWeight: "bold",
              width: "calc(13px) !important",
            },
            cellStyle: {
              textAlign: "center",
              padding: "5px 10px",
            },
          }}
        ></MaterialTable>
      </FormsContainer>
      <Row style={{ backgroundColor: themeConfig.neutral.white, margin: "0" }}>
        <Col md="12">
          {allPages > 0 && rowsPerPage && rowsPerPageOptions && (
            <TablePagination
              component="div"
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
              count={allPages}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={rowsPerPageOptions}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </Col>
      </Row>
    </>
  );
};

export default ListOfForms;
